import React, { useMemo } from 'react';
import { ExperimentTuningValuesDTO } from 'business/models/Models';
import PlateImagesRenderer from './PlateImagesRenderer';
import { PlateImageStructure } from 'components/Experiment/constants';
import { usePlateTuningWindow } from 'components/well/hooks';

interface Props {
  plateImagesStructure: PlateImageStructure[];
  captureProfileId: number;
  zoomLevel: number;
  canvasRefs: any;
  experimentTuningValues: ExperimentTuningValuesDTO[];
  plateRows: number;
  plateCols: number;
}

const PlatesImagesViewer = (props: Props) => {
  const {
    plateImagesStructure,
    captureProfileId,
    zoomLevel,
    canvasRefs,
    experimentTuningValues,
    plateRows,
    plateCols,
  } = props;

  const tuningWindow = usePlateTuningWindow(
    captureProfileId,
    experimentTuningValues,
    plateImagesStructure,
  );

  const platesImagesRenderer = useMemo(() => {
    return plateImagesStructure.map((plateImage) => (
      <PlateImagesRenderer
        key={`plateImageRenderer_${plateImage.plateId}`}
        imageTuningValues={tuningWindow}
        captureProfileId={captureProfileId}
        canvasRefs={canvasRefs}
        zoomLevel={zoomLevel}
        plateRows={plateRows}
        plateCols={plateCols}
        {...plateImage}
      />
    ));
  }, [plateImagesStructure, tuningWindow, captureProfileId, canvasRefs, zoomLevel]);

  return <>{platesImagesRenderer}</>;
};

export default PlatesImagesViewer;
